<modal
  [id]="modalId"
  [headerIcon]="headerIcon()"
  header="Roles"
  widthClass="md:tw-w-[680px] lg:tw-w-[976px] xl:tw-w-[1065px]"
  heightClass="tw-h-[min(90vh,800px)]"
  bodyClass="tw-overflow-hidden"
  (onCloseModal)="onModalClosed()"
>
  <div slot="body" class="tw-flex tw-flex-col tw-flex-1 tw-min-h-0 tw-h-full">
    <p class="tw-shrink-0 tw-text-sm lg:tw-text-base tw-font-normal tw-text-gray-500 tw-font-inter tw-mb-4">Compare user roles and their capabilities in the system.</p>
    <div class="roles-table-scroll tw-flex-1 tw-min-h-0 tw-min-w-0 tw-overflow-y-auto tw-overflow-x-hidden">
      <div class="roles-table-scroll-content tw-w-full tw-min-w-0">
        <app-generic-table
          class="roles-table_grid tw-w-full tw-min-w-0 tw-h-auto"
          [items]="rows()"
          [trackBy]="trackBy"
          [rowKey]="rowKey"
          [stickyHeader]="true"
          [fixedFirstColumn]="'below-xl'"
          [virtualScroll]="false"
          [responsiveColumns]="false"
        >
          <ng-template #permissionCell let-value>
            @if (!isYesNoValue(value)) {
              <span class="tw-font-inter tw-text-sm tw-font-normal tw-text-gray-900 tw-text-center tw-leading-5">{{ value }}</span>
            } @else if (value === 'Yes') {
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M7.15541 18.3346C6.82899 18.3362 6.51503 18.1829 6.28067 17.9075L0.37744 10.9637C0.259778 10.8245 0.165894 10.6585 0.101148 10.4753C0.0364024 10.2921 0.00206288 10.0952 9.0224e-05 9.89587C-0.00389373 9.49333 0.124201 9.10537 0.356196 8.81732C0.588191 8.52927 0.905082 8.36473 1.23716 8.3599C1.56923 8.35507 1.88929 8.51035 2.12691 8.79157L7.1604 14.7098L17.8722 2.09931C18.1102 1.81809 18.4305 1.66298 18.7628 1.66809C19.0951 1.6732 19.4122 1.83813 19.6442 2.12658C19.8762 2.41503 20.0041 2.80338 19.9999 3.2062C19.9957 3.60901 19.8596 3.9933 19.6217 4.27452L8.03014 17.9075C7.79578 18.1829 7.48182 18.3362 7.15541 18.3346Z" fill="#0E9F6E"/>
              </svg>
            } @else {
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M12.0165 10L19.5646 2.45182C19.7008 2.32027 19.8095 2.16291 19.8842 1.98893C19.959 1.81494 19.9983 1.62781 19.9999 1.43846C20.0016 1.24911 19.9655 1.06132 19.8938 0.886065C19.8221 0.710806 19.7162 0.551583 19.5823 0.417685C19.4484 0.283788 19.2892 0.177898 19.1139 0.106194C18.9387 0.0344901 18.7509 -0.00159158 18.5615 5.38441e-05C18.3722 0.00169926 18.1851 0.0410392 18.0111 0.115778C17.8371 0.190517 17.6797 0.299158 17.5482 0.435362L10 7.98354L2.45182 0.435362C2.18286 0.175592 1.82263 0.031852 1.44872 0.0351012C1.07481 0.0383503 0.717138 0.188329 0.452733 0.452733C0.188329 0.717138 0.0383503 1.07481 0.0351012 1.44872C0.031852 1.82263 0.175592 2.18286 0.435362 2.45182L7.98354 10L0.435362 17.5482C0.299158 17.6797 0.190517 17.8371 0.115778 18.0111C0.0410392 18.1851 0.00169926 18.3722 5.38441e-05 18.5615C-0.00159158 18.7509 0.0344901 18.9387 0.106194 19.1139C0.177898 19.2892 0.283788 19.4484 0.417685 19.5823C0.551583 19.7162 0.710806 19.8221 0.886065 19.8938C1.06132 19.9655 1.24911 20.0016 1.43846 19.9999C1.62781 19.9983 1.81494 19.959 1.98893 19.8842C2.16291 19.8095 2.32027 19.7008 2.45182 19.5646L10 12.0165L17.5482 19.5646C17.8171 19.8244 18.1774 19.9681 18.5513 19.9649C18.9252 19.9616 19.2829 19.8117 19.5473 19.5473C19.8117 19.2829 19.9616 18.9252 19.9649 18.5513C19.9681 18.1774 19.8244 17.8171 19.5646 17.5482L12.0165 10Z" fill="#E02424"/>
              </svg>
            }
          </ng-template>

          <div appGenericTableColumn field="role" header="Permissions" minWidth="140px" smWidth="174px" width="268px" widthXl="268px">
            <ng-template appGenericTableCellDef let-row>
              <span class="tw-font-inter tw-text-sm tw-font-normal tw-text-gray-900">{{ row.role }}</span>
            </ng-template>
          </div>

          <div appGenericTableColumn field="owner" header="Owner" align="center" minWidth="72px" smWidth="80px" width="76px" widthXl="149.8px">
            <ng-template appGenericTableCellDef let-row>
              <ng-container [ngTemplateOutlet]="permissionCell" [ngTemplateOutletContext]="{ $implicit: row.owner }"></ng-container>
            </ng-template>
          </div>

          <div appGenericTableColumn [field]="UserRoles.ADMIN" header="Admin" align="center" minWidth="72px" smWidth="125px" width="124px" widthXl="149.8px">
            <ng-template appGenericTableCellDef let-row>
              <ng-container [ngTemplateOutlet]="permissionCell" [ngTemplateOutletContext]="{ $implicit: row[UserRoles.ADMIN] }"></ng-container>
            </ng-template>
          </div>

          <div appGenericTableColumn [field]="UserRoles.COLLABORATOR" header="Collaborator" align="center" minWidth="129px" smWidth="131px" width="129px" widthXl="149.8px">
            <ng-template appGenericTableCellDef let-row>
              <ng-container [ngTemplateOutlet]="permissionCell" [ngTemplateOutletContext]="{ $implicit: row[UserRoles.COLLABORATOR] }"></ng-container>
            </ng-template>
          </div>

          <div appGenericTableColumn [field]="UserRoles.ACCOUNTANT" header="Accountant" align="center" minWidth="96px" smWidth="124px" width="124px" widthXl="149.8px">
            <ng-template appGenericTableCellDef let-row>
              <ng-container [ngTemplateOutlet]="permissionCell" [ngTemplateOutletContext]="{ $implicit: row[UserRoles.ACCOUNTANT] }"></ng-container>
            </ng-template>
          </div>

          <div appGenericTableColumn [field]="UserRoles.VIEWER" header="Viewer" align="center" minWidth="72px" smWidth="200px" width="207px" widthXl="149.8px">
            <ng-template appGenericTableCellDef let-row>
              <ng-container [ngTemplateOutlet]="permissionCell" [ngTemplateOutletContext]="{ $implicit: row[UserRoles.VIEWER] }"></ng-container>
            </ng-template>
          </div>
        </app-generic-table>
      </div>
    </div>
  </div>
</modal>
